import React from 'react';
import { Provider } from 'react-redux';
import PathBuilder from './index';
import pathBuilderStore from '../../stores/PathBuilderStore.js';

const PathBuilderRoot = props => (
  <Provider store={pathBuilderStore(props)}>
    <PathBuilder />
  </Provider>
);

export default PathBuilderRoot;
